import { useEffect } from 'react';

export default function TawkWidget({ propertyId, pageId = 'default' }) {
	useEffect(() => {
		if (!propertyId) return;

		// Prevent duplicate injection (React 18 StrictMode dev double-mount)
		if (document.getElementById('tawk-script')) return;

		// Match Tawk snippet globals
		window.Tawk_API = window.Tawk_API || {};
		window.Tawk_LoadStart = new Date();

		const s1 = document.createElement('script');
		s1.id = 'tawk-script';
		s1.async = true;
		s1.src = `https://embed.tawk.to/${propertyId}/${pageId}`;
		s1.charset = 'UTF-8';
		s1.setAttribute('crossorigin', '*');

		const s0 = document.getElementsByTagName('script')[0];
		if (s0 && s0.parentNode) {
			s0.parentNode.insertBefore(s1, s0);
		} else {
			document.body.appendChild(s1);
		}

		return () => {
			// Keep widget persistent by default
		};
	}, [propertyId, pageId]);

	return null;
}


